import {ngAsync} from '../utils/ng-@decorators';
import type {
    Directory,
    DirectoryInsight,
    DirectoryNestedInsight,
    DirectoryNode,
    FinishedActionResponse,
    FinishedSaveResponse
} from 'typings/portaro.be.types';
import type {AjaxService} from 'core/data-services/ajax.service';

export class DirectoryDataService {
    public static serviceName = 'directoryDataService';

    public static readonly ROUTE = 'directories';
    public static readonly NEW_ROUTE = 'directories/new';


    /*@ngInject*/
    constructor(private ajaxService: AjaxService) {
    }

    @ngAsync()
    public async getDirectoryById(id: number): Promise<Directory> {
        return this.ajaxService
            .createRequest(`${DirectoryDataService.ROUTE}/${id}`)
            .get();
    }

    @ngAsync()
    public async getDirectoryTree(rootDirectoryId: number): Promise<DirectoryNode> {
        return this.ajaxService
            .createRequest(`${DirectoryDataService.ROUTE}/${rootDirectoryId}/tree`)
            .get();
    }

    @ngAsync()
    public async getInsight(directoryId: number, forbiddenFileId: number, forbiddenFileCategoryIds: number[]): Promise<DirectoryInsight> {
        return this.ajaxService
            .createRequest(`${DirectoryDataService.ROUTE}/${directoryId}/insight`)
            .get({forbiddenFile: forbiddenFileId, forbiddenFileCategory: forbiddenFileCategoryIds});
    }

    @ngAsync()
    public async getNestedInsight(directoryId: number, forbiddenFileId: number, forbiddenFileCategoryIds: number[]): Promise<DirectoryNestedInsight> {
        return this.ajaxService
            .createRequest(`${DirectoryDataService.ROUTE}/${directoryId}/nested-insight`)
            .get({forbiddenFile: forbiddenFileId, forbiddenFileCategory: forbiddenFileCategoryIds});
    }

    @ngAsync()
    public async createSubdirectory(parentDirectoryId: number, name?: string): Promise<FinishedSaveResponse<Directory>> {
        return this.ajaxService
            .createRequest(`${DirectoryDataService.NEW_ROUTE}`)
            .post({parentDirectory: parentDirectoryId, name});
    }

    @ngAsync()
    public async editDirectory(directory: Directory): Promise<FinishedSaveResponse<Directory>> {
        return this.ajaxService
            .createRequest(DirectoryDataService.ROUTE)
            .post({
                directory: directory.id,
                name: directory.name,
                order: directory.order,
                accessType: directory.accessType.id,
                confirmed: false
            });
    }

    @ngAsync()
    public async deleteDirectory(directory: Directory): Promise<FinishedActionResponse> {
        return this.ajaxService
            .createRequest(`${DirectoryDataService.ROUTE}/${directory.id}`)
            .delete();
    }
}